export interface IOrderStatus {
  sendEmail: boolean;
  orderStatus: string;
  orderId: string;
}
